/**
 * Determine if a color is a light color.
 * Supports both HEX and RGB(A) formats.
 * @see https://gist.github.com/krabs-github/ec56e4f1c12cddf86ae9c551aa9d9e04
 */
export function isLightMode(color: string): boolean {
  let r: number, g: number, b: number;

  if (color.startsWith("rgb")) {
    const rgbMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    if (!rgbMatch || (rgbMatch && rgbMatch.length === 0)) {
      throw new Error(`Invalid RGB(A) color format: ${color}`);
    }

    r = parseInt(rgbMatch[1]!, 10);
    g = parseInt(rgbMatch[2]!, 10);
    b = parseInt(rgbMatch[3]!, 10);
  } else if (color.startsWith("#")) {
    let hex = color.slice(1);

    // Handle shorthand hex e.g. #fff
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }

    if (hex.length !== 6 || !/^[0-9a-fA-F]{6}$/.test(hex)) {
      throw new Error(`Invalid HEX color format: ${color}`);
    }

    const hexColor = parseInt(hex, 16);
    r = (hexColor >> 16) & 255;
    g = (hexColor >> 8) & 255;
    b = hexColor & 255;
  } else {
    throw new Error(`Unsupported color format: ${color}`);
  }

  // HSP color model equation: https://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return hsp > 127.5;
}
